import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CompaniesResponse, Company } from '@shared/models';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  #http = inject(HttpClient);
  #apiUrl = environment.apiUrl;
  #authHeaders = new HttpHeaders({
    Authorization: '',
  });

  fetchCompanies(): Observable<Company[]> {
    return this.#http
      .get<CompaniesResponse>(`${this.#apiUrl}/api/companies`, {
        headers: this.#authHeaders,
      })
      .pipe(
        map((resp) => {
          return resp.message;
        })
      );
  }
}
